import { VF_DATE_PICKER } from 'AppSrc/core/components/forms/form-base-components/v-f-date-picker';
import {
  INLINE_ERRORS,
  commonValidation,
  cleanUpFieldErrors,
  getDefaultFieldErrors,
} from 'AppSrc/core/components/forms/form-base-components/utility/common-validation';
import { DEFAULT_TIMEZONE } from 'AppSrc/core/utility-functions/date-functions';
import moment from 'moment-timezone';
import { scheduledStartDate } from './scheduled-start-date';
import { scheduledEndDate } from './scheduled-end-date';
import { owStartDate } from './ow-start-date';


const fieldId = 'outage_end_date';

const validator = (params) => {
  const {
    values,
    field,
  } = params;
  const {
    optional,
  } = field;
  const value = values[fieldId];


  // const maxMinutesDiff = 1;
  // const maxYearDiff = 5;

  // const thisMoment = moment.tz(values[fieldId], DEFAULT_TIMEZONE).startOf('minute');
  // const startMoment = moment.tz(values[scheduledEndDate.id], DEFAULT_TIMEZONE).startOf('minute');

  // figure out the differences between thisMoment and startMoment
  // const timeDiffMinutes = thisMoment.diff(startMoment, 'minutes');
  // const timeDiffYears = thisMoment.diff(startMoment, 'years');

  // ie, 1:00 -> 1:29 === error but 1:00 -> 1:30 is fine!
  // const lessThanMaxMinutesDiff = timeDiffMinutes >= maxMinutesDiff;
  // const moreThanMaxYearDiff = timeDiffYears >= maxYearDiff;

  const thisMoment = moment.tz(values[fieldId], DEFAULT_TIMEZONE).startOf('minute');
  const startMoment = moment.tz(values[owStartDate.id], DEFAULT_TIMEZONE).startOf('minute');
  const timeDiffMinutes = thisMoment.diff(startMoment, 'minutes');
  const maxMinutesDiff = 0; // for comparing the outage end date and time with scheduled end date and time.
  const lessThanMaxMinutesDiff = timeDiffMinutes < maxMinutesDiff;

  const dateIsAfterStart = commonValidation.date.isBeforeMinDate(value, moment(values[scheduledStartDate.id]));
  const dateIsBeforeEnd = commonValidation.date.isAfterMaxDate(value, moment(values[scheduledEndDate.id]));

  /* MAKE A DEFAULT ERRORS OBJECT */
  const errors = getDefaultFieldErrors();

  /* ERROR CHECKERS */
  const noValue = commonValidation.noValue(value, VF_DATE_PICKER);

  /* ADD ERRORS TO ERROR OBJECT */
  errors[INLINE_ERRORS].push((noValue && !optional) ? 'Please select an option' : null);
  errors[INLINE_ERRORS].push((dateIsAfterStart || dateIsBeforeEnd) || lessThanMaxMinutesDiff ? 'Outage End date/time must be after the Outage Start date/time & before the Scheduled End date/time' : null);
  // errors[INLINE_ERRORS].push(lessThanMaxMinutesDiff ? 'Outage End date/time must be at least 1min after the outage start date/time' : null);
  // errors[INLINE_ERRORS].push(moreThanMaxYearDiff ? 'Outage date/time must be within 5 years of schedule end date/time' : null);

  /* REMOVE BLANK ERRORS (because Formik gets confused) */
  return cleanUpFieldErrors(errors);
};

// This overwritten by the form :)
const initialValues = null;

const vFParams = {
  fieldTitle: 'Outage End date/time',
  displayType: 'big',
};

const owEndDate = {
  id: fieldId,
  validator,
  vFParams,
  initialValues,
  fieldType: VF_DATE_PICKER,
};

export { owEndDate };
